import { useState, useEffect } from 'react';
import { Grid, Button, CardMedia } from '@mui/material';
import unsplash from '../../api/unsplash';
import { getTokenFromLocalStorage } from '../../utils/localStorageHelpers';
import { useNavigate } from 'react-router-dom';
import { Visibility, VisibilityOff } from '@mui/icons-material';

import GlobalSnackbar from '../Snackbar';
import Safety from '../../assets/images/Safety_sx.png';
import { Hidden } from '@mui/material';

const SetPasswordLavoratore = () => {
    const [isGood, setIsGood] = useState(true);
    const [password, setPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [passwordShown, setPasswordShown] = useState(false);
    const [confirmPasswordShown, setConfirmPasswordShown] = useState(false);
    const [openSnack, setOpenSnack] = useState(false);
    const [snack, setSnack] = useState({
        severity: 'success',
        messaggio: 'Salvataggio Effettuato correttamente',
    });
    const [passwordsMatch, setPasswordsMatch] = useState(true);

    const navigate = useNavigate();

    const handleCloseSnack = () => setOpenSnack(false);

    const handleEyeClick = () => {
        setPasswordShown(!passwordShown);
    };

    const handleConfirmEyeClick = () => {
        setConfirmPasswordShown(!confirmPasswordShown);
    };

    useEffect(() => {
        if (!confirmPassword | !password) {
            return;
        } else {
            setPasswordsMatch(password === confirmPassword);
        }
    }, [password, confirmPassword]);

    useEffect(() => {
        const urlParams = new URLSearchParams(window.location.search);
        const token = urlParams.get('token');
        async function fetchData() {
            try {
                await unsplash.post(
                    'portaleLavoratori',
                    { operation: 'verifyToken', token: token },
                    {
                        headers: {
                            Authorization: `Bearer ${getTokenFromLocalStorage()}`,
                        },
                    }
                );
            } catch (error) {
                console.error('Error while fetching data');
                setIsGood(false);
            }
        }
        fetchData();
    }, []);

    const savePassword = async (e) => {
        e.preventDefault();
        const urlParams = new URLSearchParams(window.location.search);
        const token = urlParams.get('token');

        try {
            const response = await unsplash.post(
                'portaleLavoratori/changePassword',
                {
                    password,
                    confirmPassword,
                    token,
                },
                {
                    headers: {
                        Authorization: `Bearer ${getTokenFromLocalStorage()}`,
                    },
                }
            );

            navigate('/AreaLavoratore/Login');
        } catch (e) {
            const msg = e.response?.data?.error || 'Errore imprevisto';
            setSnack({ severity: 'error', messaggio: msg });
            setOpenSnack(true);
        }
    };

    return (
        <>
            <GlobalSnackbar
                severity={snack.severity}
                messaggio={snack.messaggio}
                openSnack={openSnack}
                handleCloseSnack={handleCloseSnack}
            />
            {/* //!RISISTEMA COM'ERA PRIMA  */}
            {isGood ? (
                <Grid
                    container
                    spacing={0}
                    direction="row"
                    alignItems="center"
                    display="flex"
                    minHeight="100vh"
                    flexWrap="nowrap"
                >
                    <Hidden mdDown>
                        <Grid
                            item
                            xs={6}
                            sx={{
                                margin: '30px',
                                borderRadius: '8px',
                            }}
                        >
                            <CardMedia
                                sx={{
                                    borderRadius: '8px',
                                    height: 'calc(100vh - 4rem)',
                                }}
                                component="img"
                                image={Safety}
                                alt="Safety"
                            />
                        </Grid>
                    </Hidden>
                    <Grid
                        item
                        xs={8}
                        lg={3}
                        justifyContent="center"
                        alignItems="center"
                        display="flex"
                        flexWrap="wrap"
                        gap={4}
                        style={{ margin: '0 auto' }}
                    >
                        <img
                            src={require('../../assets/images/Logo-ASTM.png')}
                            className="max-w-full h-auto"
                            width="500px"
                            alt="f"
                        />

                        <form
                            onSubmit={savePassword}
                            style={{ width: '100%', padding: '2rem' }}
                        >
                            <label
                                className="form-label fs-5"
                                htmlFor="password"
                            >
                                Password
                            </label>

                            <div className="form-outline mb-4 relative flex w-full items-center gap-4">
                                <input
                                    type={passwordShown ? 'text' : 'password'}
                                    id="password"
                                    name="password"
                                    placeholder="Inserisci la password"
                                    value={password}
                                    onChange={(e) =>
                                        setPassword(e.target.value)
                                    }
                                    className="block appearance-none w-full  mb-1  text-gray-800 border border-gray-200  py-2 px-4 text-lg leading-normal rounded bg-white fs-6"
                                />
                                <span className="input-group-text bg-transparent">
                                    {passwordShown ? (
                                        <Visibility
                                            onClick={handleEyeClick}
                                            style={{
                                                cursor: 'pointer',
                                                color: '#11526f',
                                            }}
                                        />
                                    ) : (
                                        <VisibilityOff
                                            onClick={handleEyeClick}
                                            style={{
                                                cursor: 'pointer',
                                                color: '#11526f',
                                            }}
                                        />
                                    )}
                                </span>
                            </div>
                            <label
                                htmlFor="confirm-password"
                                className="form-label fs-5"
                            >
                                Conferma Password
                            </label>
                            <div
                                className={`form-outline mb-4 relative flex items-center w-full gap-4 ${
                                    passwordsMatch && 'pb-[28px]'
                                }`}
                            >
                                <input
                                    type={
                                        confirmPasswordShown
                                            ? 'text'
                                            : 'password'
                                    }
                                    id="confirm-password"
                                    name="confirm-password"
                                    value={confirmPassword}
                                    placeholder="Conferma la password"
                                    onChange={(e) =>
                                        setConfirmPassword(e.target.value)
                                    }
                                    className={`block appearance-none w-full text-gray-800 border mb-1 ${
                                        passwordsMatch
                                            ? 'border-gray-200'
                                            : 'border-red-500'
                                    } 
                                                               
                                                                 py-2 px-4 text-lg leading-normal rounded  bg-white fs-6`}
                                />
                                <span className="input-group-text bg-transparent">
                                    {confirmPasswordShown ? (
                                        <Visibility
                                            onClick={handleConfirmEyeClick}
                                            style={{
                                                cursor: 'pointer',
                                                color: '#11526f',
                                            }}
                                        />
                                    ) : (
                                        <VisibilityOff
                                            onClick={handleConfirmEyeClick}
                                            style={{
                                                cursor: 'pointer',
                                                color: '#11526f',
                                            }}
                                        />
                                    )}
                                </span>
                            </div>
                            {!passwordsMatch && (
                                <p className="text-red-500 text-sm mb-2">
                                    Le password non corrispondono
                                </p>
                            )}

                            <Button
                                type="submit"
                                fullWidth
                                size="large"
                                variant="contained"
                                onClick={savePassword}
                                style={{
                                    padding: '8px 16px',
                                    backgroundColor: '#11526f',
                                }}
                                disabled={
                                    !password ||
                                    !confirmPassword ||
                                    !passwordsMatch
                                }
                            >
                                CONFERMA
                            </Button>
                        </form>
                    </Grid>
                </Grid>
            ) : (
                'ATTENZIONE LINK NON PIU VALIDO'
            )}
        </>
    );
};

export default SetPasswordLavoratore;
